import React, {useEffect, useState} from 'react';
import {Modal, TouchableWithoutFeedback} from 'react-native';

import {Button} from '../../Interface/Forms/Buttons/Button';

import {
  ModalOverlay,
  ModalContent,
  ModalTitle,
  ModalText,
  ModalTextHighlight,
  ModalCheckboxRow,
  ModalCheckboxText,
  ModalCheckIcon,
} from './styles';

interface Props {
  visible: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title?: string;
  highlightText: string;
  bodyText: string;
}

export function PixRefundWarningModal({
  visible,
  onClose,
  onConfirm,
  title = 'Importante',
  highlightText,
  bodyText,
}: Props) {
  const [accepted, setAccepted] = useState(false);

  useEffect(() => {
    if (visible) {
      setAccepted(false);
    }
  }, [visible]);

  const handleConfirm = () => {
    if (!accepted) {
      return;
    }

    onConfirm();
  };

  return (
    <Modal
      visible={visible}
      transparent
      animationType="fade"
      onRequestClose={onClose}>
      <TouchableWithoutFeedback onPress={onClose}>
        <ModalOverlay>
          <TouchableWithoutFeedback>
            <ModalContent>
              <ModalTitle>{title}</ModalTitle>
              <ModalTextHighlight>{highlightText}</ModalTextHighlight>
              <ModalText>{bodyText}</ModalText>

              <ModalCheckboxRow
                activeOpacity={0.7}
                onPress={() => setAccepted(!accepted)}>
                <ModalCheckIcon
                  name={accepted ? 'check-square' : 'square-o'}
                  checked={accepted}
                />
                <ModalCheckboxText>Li e entendi</ModalCheckboxText>
              </ModalCheckboxRow>

              <Button title="Continuar" enabled={accepted} onPress={handleConfirm} />
            </ModalContent>
          </TouchableWithoutFeedback>
        </ModalOverlay>
      </TouchableWithoutFeedback>
    </Modal>
  );
}
